import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import Link from '@material-ui/core/Link';
import { Link as RouteLink } from 'react-router-dom'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography'
import { inject, observer } from 'mobx-react'
import { rewardCostTypeMapping, rewardPrizeTypeMapping } from '../../constant'

const styles = theme => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
})


@withStyles(styles)
@inject('HomeStore', 'ActivityStore')
@observer
class RewardList extends Component {

  formatAction = costType => {
    return rewardCostTypeMapping[costType]
  }

  formatReward = (prizeType, prizeValue) => {
    return `${prizeValue}${rewardPrizeTypeMapping[prizeType]}`
  }

  handleClick = () => {
    this.props.ActivityStore.setRoute('points_redeem')
  }

  render() {
    const { rewardsRedeemActivity } = this.props.HomeStore

    const { classes } = this.props
    return (
      <React.Fragment>
        <Typography component="h2" variant="h6" color="textPrimary" gutterBottom>
          Rewards redeeming
        </Typography>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Action</TableCell>
              <TableCell align="right">Reward</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rewardsRedeemActivity.map(row => (
              <TableRow key={row.id}>
                <TableCell>{row.first_name} {row.last_name}</TableCell>
                <TableCell>{this.formatAction(row.cost_type)}</TableCell>
                <TableCell align='right'>{this.formatReward(row.prize_type, row.prize_value)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className={classes.seeMore}>
          <Link 
            color="primary" 
            component={RouteLink}
            to='/activity/points_redeem'
            onClick={this.handleClick}
          >
            View all reward activity
          </Link>
        </div>
      </React.Fragment>
    )
  }
}
export default RewardList